export type ArticleReadingInput = {
  title: string;
  content: string;
  sourceUrl?: string | null;
};

export function getArticleReadingData(article: ArticleReadingInput) {
  return {
    title: article.title,
    content: article.content,
    sourceUrl: article.sourceUrl ?? null,
  };
}
